import React, { useEffect, useRef, useState } from "react";

import * as R from "ramda";
import * as countries from "i18n-iso-countries";
import frenchCountryData from "i18n-iso-countries/langs/fr.json";

import appartement from "../../../../../../assets/images/svg/090-flats.svg";
import maison from "../../../../../../assets/images/svg/069-home.svg";
import palace from "../../../../../../assets/images/svg/093-palace.svg";
import hotel from "../../../../../../assets/images/svg/087-hotel.svg";
import peniche from "../../../../../../assets/images/svg/091-house-2.svg";
import divers from "../../../../../../assets/images/svg/092-camping-tent.svg";
import residenceSenior from "../../../../../../assets/images/svg/147-senior-residence.svg";


import { FormAddress} from "./forms/formAddress";

export const Address = ({ relocationDeclaration, userId, isLoading, type }) => {
	countries.registerLocale(frenchCountryData);
	const contractType = ["", "Propriétaire", "Locataire", "Autre"];
	const assetTypeLogo = ["", appartement, maison, palace, hotel, peniche, divers, residenceSenior];

	const [editMode, setEditMode] = useState(false);

	return (
		<section className="card mb-sm">
			<div className="card-header pb-0">
				<div className="grid grid-sm-2 align-items-center">
					<h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">{type === "oldAddress" ? "Adresse actuelle" : "Nouvelle adresse postale"}</h2>
					<div className="grid grid-2 ml-sm-auto align-items-center">
						<button
							type="button"
							className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"
							onClick={() => {
								setEditMode(true);
							}}>
							<i className="eva eva-edit-2-outline align-middle fs-lead"></i>
						</button>
						<div className="custom-control custom-switch mx-auto">
							<input type="checkbox" className="custom-control-input" id={`flexSwitchCheckDefaul2t-${type}`} required="required" defaultChecked={relocationDeclaration?.onBoardingStep > 2} />
							<label className="custom-control-label" htmlFor={`flexSwitchCheckDefaul2t-${type}`}>
								Valider
							</label>
						</div>
					</div>
				</div>
				<hr className="mb-0" />
			</div>
			{!editMode ? (
				<div className="card-body grid grid-sm-2 grid-lg-3 grid-xl-6 gy-3">
					<div className="block flex-row align-items-center">
						<img className="img-fluid mr-3 h-4" src={assetTypeLogo[relocationDeclaration?.[type]?.addressType]} alt="maison" />
						<p className="h6 text-uppercase font-weight-bold my-auto">{contractType[relocationDeclaration[type]?.addressContract]}</p>
					</div>
					<div className="flex-row align-items-start grid-column-xl-2">
						<i className="eva lh-copy eva-home-outline mr-2 o-50"></i>
						<p className="h5 lh-copy my-auto">
							{relocationDeclaration[type]?.addressLine1}
							<br />
							{relocationDeclaration[type]?.addressLine2 !== "" ? (
								<>
									{relocationDeclaration[type]?.addressLine2}
									<br />
								</>
							) : (
								""
							)}
							{relocationDeclaration[type]?.postalCode} {relocationDeclaration[type]?.city}, {countries.getName(relocationDeclaration[type]?.country, "fr", { select: "official" })}
						</p>
					</div>
					{type === "newAddress" && (
						<React.Fragment>
							<div className="block">
								<h3 className="h6 font-weight-bold">Même commune</h3>
								<p className="h5">{relocationDeclaration?.sameArea ? "Oui" : "Non"}</p>
							</div>
							<div className="block">
								<h3 className="h6 font-weight-bold">Raison du déménagement</h3>
								<p className="h5">{relocationDeclaration?.reason == 0 ? "Motif personnel" : "Motif professionnel"}</p>
							</div>
							<div className="block">
								<h3 className="h6 font-weight-bold">Date d'effet du déménagement</h3>
								<p className="h5">{relocationDeclaration?.effectiveMovingDate?.toLocaleDateString("fr-FR")}</p>
							</div>
						</React.Fragment>
					)}
				</div>
			) : (
				<FormAddress relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} setEditMode={setEditMode} type={type} />
			)}
		</section>
	);
};
